module.exports = __webpack_public_path__ + "static/media/performance-info.6b6dbce0.svg";